import { render, staticRenderFns } from "./flexIndex.vue?vue&type=template&id=5e264b38&"
import script from "./flexIndex.vue?vue&type=script&lang=js&"
export * from "./flexIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports